export interface TestVideo {
  videoNumber: 1 | 2;
  uploadType: 'file' | 'url' | null;
  file: File | null;
  url: string;
  title: string;
  notes: string;
  uploaded: boolean;
  uploading: boolean;
}

export interface ApplicationData {
  id: string;
  first_name: string;
  test_token: string;
  test_link_expires_at: string | null;
  test_submitted: boolean;
  [key: string]: unknown;
}

export interface TestSubmission {
  id: string;
  application_id: string;
  video_number: 1 | 2;
  upload_type: 'file' | 'url';
  storage_path: string | null;
  video_url: string | null;
  title: string | null;
  notes: string | null;
  file_size_bytes: number | null;
  screening_status: 'pending' | 'approved' | 'flagged';
  screening_notes: string | null;
  created_at: string;
  updated_at: string;
}

export const VALID_VIDEO_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'video/x-matroska',
  'video/webm'
];

export const MAX_FILE_SIZE_BYTES = 314572800; // 300 MB

export function createEmptyVideo(videoNumber: 1 | 2): TestVideo {
  return {
    videoNumber,
    uploadType: null,
    file: null,
    url: '',
    title: '',
    notes: '',
    uploaded: false,
    uploading: false
  };
}
